import React from 'react';
import './BLSpinner.scss';

const BLSpinner: React.FC<{
  size?: 'sm'|'lg'|number|string;
  className?: string;
}> = ({ 
  size, 
  className
}) => {
  const fontSize:string = 
    size === 'sm' ? 
      '1rem'
    : size === 'lg' ?
      '2rem'
    : typeof size === 'number' ? 
      `${size}px`
    : typeof size === 'string' ?
      size
    : 'inherit';

  return <div className={`BLSpinner ${className}`} style={{fontSize}}>
    <span className="circle1"></span>
    <span className="circle2"></span>
    <span className="circle3"></span>
    <span className="sr-only visually-hidden">Loading...</span>
  </div>
}

export default BLSpinner;